import { api } from '@/api';
import { RootState } from '@/store/index';
import { Template } from '@/types/Template';
import { ActionContext, Module } from 'vuex';

export type TemplatesState = {
    templates: Template[];
};

export const templates: Module<TemplatesState, RootState> = {
    state: {
        templates: [],
    },
    mutations: {
        setTemplates(state: TemplatesState, payload) {
            state.templates = payload;
        },
    },
    getters: {
        templates: (state) => state.templates,
    },
    actions: {
        async fetchTemplates(context: ActionContext<TemplatesState, RootState>) {
            const response = await api.get('/templates');

            if (!response || !response.data) {
                throw new Error('Could not load templates');
            }

            context.commit('setTemplates', response.data.data);
        },
    },
};
